<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>{{ $t("message.consultaContenedores") }}</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button v-show="!secuencia" @click="consultar" class="btn-info btn--bigger">
            <i class="fa fa-search"></i> <span>{{ $t("message.buscar") }}</span>
          </button>
          <button v-show="puedeEditar && procesosConsultados.length > 0" @click="editarPropiedades"
            class="btn-info btn--text">
            <i class="fa fa-edit"></i> <span>Editar</span>
          </button>
          <button @click="descargarTodos" v-if="procesosConsultados.length > 0" class="btn-secondary btn--text">
            <i class="fa fa-download"></i>
            <span>{{ $t("message.descargarTodo") }}</span>
          </button>
          <button @click="copiarLinks" v-if="procesosConsultados.length > 0" class="btn-success btn--text">
            <i class="fa fa-link"></i>
            <span>{{ $t("message.copiarLinks") }}</span>
          </button>
          <button @click="enviarCorreos" v-show="propiedadConsultada !== null" class="btn-info btn--text" type="button">
            <i class="fa fa-envelope"></i><span>{{ $t("message.enviarEir") }}</span>
          </button>
          <button v-show="propiedadConsultada !== null" class="btn-primary btn--text" type="button"
            @click="verLogs('C')">
            <i class="fa fa-file"></i><span>Logs Caja</span>
          </button>
          <button v-show="
            propiedadConsultada !== null &&
            propiedadConsultada.is_maquina === 'S'
          " class="btn-primary btn--text" type="button" @click="verLogs('M')">
            <i class="fa fa-file"></i><span>Logs Máquina</span>
          </button>
        </div>
      </div>
    </div>
    <div v-if="!secuencia" class="card">
      <div class="card__content">
        <div class="row mb-0">
          <div v-show="patios.length > 0" class="col-xs-12 col-md-3">
            <div class="form-field select2">
              <div class="select2-field select2-field--stretch">
                <v-select @input="inputPatio" :options="patios" label="name" v-model="selectedPatio" id="patios">
                </v-select>
                <label for="patios">Yard</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <div class="form-field select2">
              <div class="select2-field select2-field--stretch">
                <v-select @input="consultar" :options="contenedoresFiltrados" label="nombre"
                  v-model="form.selectedContenedor" id="contenedores"></v-select>
                <label for="contenedores">{{ $t("message.contenedor") }}</label>
                <span v-if="errores.selectedContenedor" class="helper-text text-danger" slot="helper">
                  <strong>{{ errores.selectedContenedor[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div v-if="
            propiedadConsultada !== null &&
            propiedadConsultada.customer !== null &&
            propiedadConsultada.customer !== undefined
          " class="col-xs-12 col-md-9">
            <p>
              <label class="big-label"><strong>{{ $t("message.patio") }}:</strong>
                {{
                  propiedadConsultada.yard !== null
                    ? propiedadConsultada.yard.name
                    : ""
                }}
                [{{ propiedadConsultada.yard_code }}]</label>
              <label class="big-label"><strong>{{ $t("message.cliente") }}:</strong>
                {{
                  propiedadConsultada.customer !== null &&
                    propiedadConsultada.customer !== undefined
                    ? propiedadConsultada.customer.name
                    : ""
                }}
                [{{ propiedadConsultada.customer_code }}]</label>
              <label class="big-label"><strong>Usuario creador:</strong>
                {{ propiedadConsultada.cod_usuario }}</label>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="propiedadConsultada !== null" class="card mt-3">
      <div class="card__title">
        <h5>{{ propiedadConsultada.number }}</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-8">
            <h5>{{ $t("message.informacionContenedor") }}</h5>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>{{ $t("message.eirCaja") }}</th>
                    <th>{{ $t("message.eirMaquina") }}</th>
                    <th>{{ $t("message.conductor") }}</th>
                    <th>{{ $t("message.fechaIngreso") }}</th>
                    <th>{{ $t("message.placa") }}</th>
                    <th>{{ $t("message.observacionRep") }}</th>
                    <th>{{ $t("message.observacionRepM") }}</th>
                    <th>{{ $t("message.conductorOut") }}</th>
                    <th>{{ $t("message.fechaSalida") }}</th>
                    <th>{{ $t("message.placaOut") }}</th>
                    <th>{{ $t("message.eirCajaOut") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <button @click="imprimirEir" v-show="propiedadConsultada.eir_in !== null"
                        class="btn--outline btn-info">
                        {{ propiedadConsultada.eir_in }}
                      </button>
                    </td>
                    <td>
                      <button @click="imprimirEirMaquina" v-show="propiedadConsultada.eir_maquina_in !== null"
                        class="btn--outline btn-secondary">
                        {{ propiedadConsultada.eir_maquina_in }}
                      </button>
                    </td>
                    <td>{{ propiedadConsultada.trucking_in }}</td>
                    <td>{{ propiedadConsultada.gate_in_date }}</td>
                    <td>{{ propiedadConsultada.layout }}</td>
                    <td>
                      {{ propiedadConsultada.kim_observacion_reparacion }}
                    </td>
                    <td>
                      {{ propiedadConsultada.kim_observacion_reparacion_m }}
                    </td>
                    <td>{{ propiedadConsultada.trucking_out }}</td>
                    <td>{{ propiedadConsultada.gate_out_date }}</td>
                    <td>{{ propiedadConsultada.segmento }}</td>
                    <td>
                      <button @click="imprimirEirOut" v-show="propiedadConsultada.eir_out !== null"
                        class="btn--outline btn-success">
                        {{ propiedadConsultada.eir_out }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <h5>{{ $t("message.observaciones") }}</h5>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>{{ $t("message.tipo") }}</th>
                    <th>{{ $t("message.usuario") }}</th>
                    <th>{{ $t("message.observacion") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(
                      observacion, index
                    ) in propiedadConsultada.observaciones" :key="index">
                    <td>{{ observacion.modulo }}</td>
                    <td>{{ observacion.nombre_usuario }}</td>
                    <td>{{ observacion.observacion }}</td>
                  </tr>
                  <tr v-show="
                    propiedadConsultada.observaciones !== undefined &&
                    propiedadConsultada.observaciones !== null &&
                    propiedadConsultada.observaciones.length === 0
                  ">
                    <td colspan="3">
                      <strong>{{ $t("message.sinDatos") }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="mt-3 col-xs-12">
            <div class="table-responsive">
              <table class="table--centered">
                <tbody>
                  <tr>
                    <td>
                      <strong>{{ $t("message.firmaConductor") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaInspectorCaja") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaInspectorMaquina") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaSupEstCaja") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaSupEstMaq") }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_conductor,
                          },
                          $t('message.firmaConductor')
                        )
                      " v-if="propiedadConsultada.firma_conductor" :src="propiedadConsultada.firma_conductor"
                        alt="firma_conductor" width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_conductor" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_inspector_caja,
                          },
                          $t('message.firmaInspectorCaja')
                        )
                      " v-if="propiedadConsultada.firma_inspector_caja" :src="propiedadConsultada.firma_inspector_caja"
                        alt="firma_inspector_caja" width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_inspector_caja" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_inspector_maquina,
                          },
                          $t('message.firmaInspectorMaquina')
                        )
                      " v-if="propiedadConsultada.firma_inspector_maquina"
                        :src="propiedadConsultada.firma_inspector_maquina" alt="firma_inspector_maquina" width="150px"
                        height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_inspector_maquina" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_supervisor_est,
                          },
                          $t('message.firmaSupEstCaja')
                        )
                      " v-if="propiedadConsultada.firma_supervisor_est" :src="propiedadConsultada.firma_supervisor_est"
                        alt="firma_supervisor_est" width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_supervisor_est" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_supervisor_est_maq,
                          },
                          $t('message.firmaSupEstMaq')
                        )
                      " v-if="propiedadConsultada.firma_supervisor_est_maq"
                        :src="propiedadConsultada.firma_supervisor_est_maq" alt="firma_supervisor_est_maq" width="150px"
                        height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_supervisor_est_maq" v-else />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <strong>{{ $t("message.firmaSupRepCaja") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaSupRepMaq") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaInspOut") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaCondOut") }}</strong>
                    </td>
                    <td>
                      <strong>{{ $t("message.firmaSupSal") }}</strong>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_supervisor_rep_caja,
                          },
                          $t('message.firmaSupRepCaja')
                        )
                      " v-if="propiedadConsultada.firma_supervisor_rep_caja"
                        :src="propiedadConsultada.firma_supervisor_rep_caja" alt="firma_supervisor_rep_caja"
                        width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_supervisor_rep_caja" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_supervisor_rep_maq,
                          },
                          $t('message.firmaSupRepMaq')
                        )
                      " v-if="propiedadConsultada.firma_supervisor_rep_maq"
                        :src="propiedadConsultada.firma_supervisor_rep_maq" alt="firma_supervisor_rep_maq" width="150px"
                        height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_supervisor_rep_maq" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_inspector_out,
                          },
                          $t('message.firmaInspOut')
                        )
                      " v-if="propiedadConsultada.firma_inspector_out" :src="propiedadConsultada.firma_inspector_out"
                        alt="firma_inspector_out" width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_inspector_out" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_conductor_out,
                          },
                          $t('message.firmaCondOut')
                        )
                      " v-if="propiedadConsultada.firma_conductor_out" :src="propiedadConsultada.firma_conductor_out"
                        alt="firma_conductor_out" width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_conductor_out" v-else />
                    </td>
                    <td>
                      <img class="img" @click="
                        verImagen(
                          {
                            url: propiedadConsultada.firma_supervisor_sal,
                          },
                          $t('message.firmaSupSal')
                        )
                      " v-if="propiedadConsultada.firma_supervisor_sal" :src="propiedadConsultada.firma_supervisor_sal"
                        alt="firma_supervisor_sal" width="150px" height="100px" />
                      <img width="150px" height="100px" :src="pathSinImagen" alt="firma_supervisor_sal" v-else />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xs-12 col-md-12">
            <h5>{{ $t("message.observacionesRep") }}</h5>
            <div class="row">
              <div class="col-xs-12 col-md-6" v-for="(
                  proceso, index
                ) in propiedadConsultada.procesosReparacion" :key="index">
                <item-grupo-contenedor v-if="
                  proceso.imagenes !== undefined &&
                  proceso.imagenes !== null &&
                  proceso.imagenes.length > 0
                " :imagenes="proceso.imagenes" :errorText="errorText" :usuarioText="userText" @verImagen="verImagen"
                  :copyLinks="copyLinks" :downloadGroup="downloadGroup" :title="proceso.grupo"></item-grupo-contenedor>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-4">
            <h5>{{ $t("message.observacionSalida") }}</h5>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>{{ $t("message.usuario") }}</th>
                    <th>{{ $t("message.observacion") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ propiedadConsultada.kim_usu_obs_out }}</td>
                    <td>{{ propiedadConsultada.kim_observacion_out }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <h5>Amounts</h5>
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th>Amount Machine Yard</th>
                    <th>Amount Box Yard</th>
                    <th>Amount Machine</th>
                    <th>Amount Box</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ moneyFormat(propiedadConsultada.amount_m) }}</td>
                    <td>{{ moneyFormat(propiedadConsultada.amount_b) }}</td>
                    <td>
                      {{ moneyFormat(propiedadConsultada.valor_maquina) }}
                    </td>
                    <td>{{ moneyFormat(propiedadConsultada.valor_caja) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="
          !(secuencia !== '' && secuencia !== null && secuencia !== undefined)
        " class="row">
          <div class="col-xs-12">
            <h5>Estado del contenedor</h5>
            <table-bar :rows="[
              propiedadConsultada.garita_finalizada === 'S',
              ((propiedadConsultada.is_caja === 'S' &&
                propiedadConsultada.inspection_b === 'S') ||
                propiedadConsultada.is_caja !== 'S') &&
              ((propiedadConsultada.is_maquina === 'S' &&
                propiedadConsultada.inspection_m === 'S') ||
                propiedadConsultada.is_maquina !== 'S') &&
              !(
                propiedadConsultada.is_caja === 'N' &&
                propiedadConsultada.is_maquina === 'N'
              ),
              ((propiedadConsultada.is_caja === 'S' &&
                propiedadConsultada.estimado_b === 'S') ||
                propiedadConsultada.is_caja !== 'S') &&
              ((propiedadConsultada.is_maquina === 'S' &&
                propiedadConsultada.estimado_m === 'S') ||
                propiedadConsultada.is_maquina !== 'S') &&
              !(
                propiedadConsultada.is_caja === 'N' &&
                propiedadConsultada.is_maquina === 'N'
              ),
              propiedadConsultada.is_caja === 'S' &&
              propiedadConsultada.aprobado_b === 'S' &&
              (propiedadConsultada.is_maquina === 'N' ||
                (propiedadConsultada.is_maquina === 'S' &&
                  propiedadConsultada.aprobado_m === 'S')),
              ((propiedadConsultada.is_caja === 'S' &&
                propiedadConsultada.repaired === 'S') ||
                propiedadConsultada.is_caja !== 'S') &&
              ((propiedadConsultada.is_maquina === 'S' &&
                propiedadConsultada.repaired_m === 'S') ||
                propiedadConsultada.is_maquina !== 'S') &&
              !(
                propiedadConsultada.is_caja === 'N' &&
                propiedadConsultada.is_maquina === 'N'
              ),
              propiedadConsultada.kim_salida === 'S' ||
              propiedadConsultada.status === 'T',
            ]"></table-bar>
          </div>
        </div>
      </div>
    </div>
    <tabs @changed="tabChanged">
      <tab id="IN" :is-disabled="!permiteEs" name="IN">
        <div v-if="form.modulo === 'IN' && propiedadConsultada != null">
          <div class="table-responsive">
            <table>
            <thead>
              <tr>
                <th>
                  {{ $t("message.locacion") }}
                </th>
                <th>
                  {{ $t("message.observacion") }}
                </th>
                <th>Tipo</th>
                <th>Interno</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(
                  row, index
                ) in propiedadConsultada.observaciones_localizacion_in" :key="index">
                <td>{{ row.localizacion }}</td>
                <td>{{ row.observacion }}</td>
                <td>{{ row.tipo === 'C'?'Caja':'Máquina' }}</td>
                <td>{{ row.interno }}</td>
              </tr>
              <tr v-show="
                propiedadConsultada.observaciones_localizacion_in
                  .length === 0
              ">
                <td colspan="4">
                  {{ $t("message.sinDatos") }}
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div v-for="(proceso, index) in procesosConsultados" :key="index">
            <item-grupo-contenedor v-if="
              proceso.imagenes !== undefined &&
              proceso.imagenes !== null &&
              proceso.imagenes.length > 0
            " :imagenes="proceso.imagenes" :errorText="errorText" :usuarioText="userText" @verImagen="verImagen"
              :copyLinks="copyLinks" :downloadGroup="downloadGroup" :title="proceso.grupo"></item-grupo-contenedor>
          </div>
        </div>
        <div class="mb-2" v-if="procesosConsultados.length === 0">
          <strong>{{ $t("message.sinDatos") }}</strong>
        </div>
      </tab>
      <tab id="EST" :is-disabled="!permiteEs" :name="$t('message.estimacion')">
        <div v-if="form.modulo === 'EST'">
          <div v-for="(proceso, index) in procesosConsultados" :key="index">
            <item-grupo-contenedor v-if="
              proceso.imagenes !== undefined &&
              proceso.imagenes !== null &&
              proceso.imagenes.length > 0
            " :imagenes="proceso.imagenes" :errorText="errorText" :usuarioText="userText" @verImagen="verImagen"
              :copyLinks="copyLinks" :downloadGroup="downloadGroup" :title="proceso.grupo"></item-grupo-contenedor>
          </div>
        </div>
        <div class="mb-2" v-if="procesosConsultados.length === 0">
          <strong>{{ $t("message.sinDatos") }}</strong>
        </div>
      </tab>
      <tab id="REP" :is-disabled="!permiteRep" :name="$t('message.reparacion')">
        <div v-if="form.modulo === 'REP'">
          <div v-for="(item, index) in procesosConsultados" :key="index">
            <item-contenedor :showIfNoImages="false" :item="item"
              v-if="item.grupos !== undefined && item.grupos !== null" @verImagen="verImagen"></item-contenedor>
          </div>
        </div>
        <div class="mb-2" v-if="procesosConsultados.length === 0">
          <strong>{{ $t("message.sinDatos") }}</strong>
        </div>
      </tab>
      <tab id="OUT" :is-disabled="!permiteOut" :name="$t('message.salida')">
        <div v-if="propiedadConsultada !== null" class="table-responsive">
          <table v-if="form.modulo === 'OUT'" class="table--centered">
            <thead>
              <tr>
                <th>{{ $t("message.ventila") }}</th>
                <th>{{ $t("message.temperatura") }}</th>
                <th>{{ $t("message.remarksSalida") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <img class="img" @click="
                    verImagen(
                      {
                        url: propiedadConsultada.f_ventila_out,
                      },
                      $t('message.ventila')
                    )
                  " v-if="propiedadConsultada.f_ventila_out" :src="propiedadConsultada.f_ventila_out"
                    alt="f_ventila_out" width="250px" height="175px" />
                  <img width="250px" height="175px" :src="pathSinImagen" alt="f_ventila_out" v-else /><br />
                  <strong>{{ propiedadConsultada.kim_ventila }}</strong>
                </td>
                <td>
                  <img class="img" @click="
                    verImagen(
                      {
                        url: propiedadConsultada.f_temp_out,
                      },
                      $t('message.temperatura')
                    )
                  " v-if="propiedadConsultada.f_temp_out" :src="propiedadConsultada.f_temp_out" alt="f_temp_out"
                    width="250px" height="175px" />
                  <img width="250px" height="175px" :src="pathSinImagen" alt="f_temp_out" v-else /><br />
                  <strong>{{ propiedadConsultada.monitoring }}</strong>
                </td>
                <td>
                  <table>
                    <thead>
                      <tr>
                        <th>
                          {{ $t("message.locacion") }}
                        </th>
                        <th>
                          {{ $t("message.observacion") }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(
                          row, index
                        ) in propiedadConsultada.observaciones_localizacion" :key="index">
                        <td>{{ row.localizacion }}</td>
                        <td>{{ row.observacion }}</td>
                      </tr>
                      <tr v-show="
                        propiedadConsultada.observaciones_localizacion
                          .length === 0
                      ">
                        <td colspan="2">
                          {{ $t("message.sinDatos") }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="form.modulo === 'OUT'">
          <div v-for="(item, index) in procesosConsultados" :key="index">
            <item-contenedor :showIfNoImages="false" :item="item"
              v-if="item.grupos !== undefined && item.grupos !== null" @verImagen="verImagen"></item-contenedor>
          </div>
        </div>
        <div class="mb-2" v-if="procesosConsultados.length === 0">
          <strong>{{ $t("message.sinDatos") }}</strong>
        </div>
      </tab>
    </tabs>
    <modal scrollable name="visor" width="60%" height="auto">
      <visor-imagen @cerrar="cerrarVisor" :src="srcImagen" :title="imagenTitle"></visor-imagen>
    </modal>
    <modal name="enviarEir" width="60%" height="auto" scrollable>
      <enviar-eir :correosCliente="
        propiedadConsultada != null
          ? propiedadConsultada.email_transportista
          : ''
      " :secuencia="secuencia" :labelEmail="labelEmail" :cancelarText="cancelarText"
        :enviarCorreoText="enviarCorreoText" :requiredEmailText="requiredEmailText" :emailsSent="emailsSent"
        :errorText="errorText" :avisoText="avisoText" :errorValidationText="errorValidacionText" @enviado="eirEnviado"
        @cancelar="cancelarCorreo" tipo="in" :number="propiedadConsultada !== null ? propiedadConsultada.number : ''">
      </enviar-eir>
    </modal>
    <modal :clickToClose="false" width="75%" height="auto" scrollable name="editarPropiedades">
      <editar-unidad :historico="secuencia == undefined ? false : true"
        :numeroContenedor="form.selectedContenedor != null ? form.selectedContenedor.number : null"
        :numeroSecuencia="secuencia == undefined ? '' : secuencia + ''" :puede_editar_status="puede_editar_status"
        :puede_eliminar="secuencia != undefined ? false : puede_eliminar" 
        :puede_editar_gate_in="puede_editar_gate_in" 
        :puede_editar_gate_out="puede_editar_gate_out" 
        :puede_editar_in="puede_editar_in"
        :puede_editar_out="puede_editar_out"
        :puede_editar_caja="puede_editar_caja"
        :puede_editar_maquina="puede_editar_maquina"
        :puede_enviar_edi_in="puede_enviar_edi_in"
        :puede_enviar_edi_out="puede_enviar_edi_out"
        @cerrarUnidad="cerrarUnidad"
        @eliminarUnidad="eliminarUnidad" v-model="currentUnidad"
        ref="editarUnidad">
      </editar-unidad>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    contenedores: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    permiteIn: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteEs: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteOut: {
      type: Boolean,
      required: false,
      default: false,
    },
    permiteRep: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "Consulta de contenedores",
    },
    descripcion: {
      type: String,
      required: false,
      default: "Información de la consulta",
    },
    patioLabel: {
      type: String,
      required: false,
      default: "Patio",
    },
    contenedorLabel: {
      type: String,
      required: false,
      default: "Contenedor",
    },
    tipoFechaLabel: {
      type: String,
      required: false,
      default: "Tipo de fecha",
    },
    hoyLabel: {
      type: String,
      required: false,
      default: "Hoy",
    },
    ayerLabel: {
      type: String,
      required: false,
      default: "Ayer",
    },
    personalizadaLabel: {
      type: String,
      required: false,
      default: "Personalizada",
    },
    filtrarFechasLabel: {
      type: String,
      required: false,
      default: "Filtrar por fechas",
    },
    buscarText: {
      type: String,
      required: false,
      default: "Consultar",
    },
    clienteLabel: {
      type: String,
      required: false,
      default: "Cliente",
    },
    descargarTodoText: {
      type: String,
      required: false,
      default: "Descargar todo",
    },
    errorValidacionText: {
      type: String,
      required: false,
      default: "Hubo un error de validación.",
    },
    avisoText: {
      type: String,
      required: false,
      default: "Aviso",
    },
    errorText: {
      type: String,
      required: false,
      default: "Hubo un error, intente nuevamente.",
    },
    notFound: {
      type: String,
      required: false,
      default: "No se encontró resultados.",
    },
    copyAllLinks: {
      type: String,
      required: false,
      default: "Copiar todos los enlaces",
    },
    copyLinks: {
      type: String,
      required: false,
      default: "Copiar enlaces",
    },
    downloadGroup: {
      type: String,
      required: false,
      default: "Descargar grupo",
    },
    inText: {
      type: String,
      required: false,
      default: "IN",
    },
    out: {
      type: String,
      required: false,
      default: "OUT",
    },
    estimate: {
      type: String,
      required: false,
      default: "ESTIMATE",
    },
    imprimirEirText: {
      type: String,
      required: false,
      default: "Imprimir EIR",
    },
    enviarCorreoText: {
      type: String,
      required: false,
      default: "Enviar EIR por correo",
    },
    usuarioText: {
      type: String,
      required: false,
      default: "Usuario",
    },
    conductorText: {
      type: String,
      required: false,
      default: "Conductor",
    },
    fechaIngresoText: {
      type: String,
      required: false,
      default: "Fecha de ingreso",
    },
    placaText: {
      type: String,
      required: false,
      default: "Placa",
    },
    requiredEmailText: {
      type: String,
      required: false,
      default: "Se requiere de al menos una dirección de correo electrónico.",
    },
    emailsSent: {
      type: String,
      required: false,
      default: "Los correos fueron enviados exitósamente.",
    },
    labelEmail: {
      type: String,
      required: false,
      default: "Correo(s) (Separados por coma)",
    },
    cancelarText: {
      type: String,
      required: false,
      default: "Cancelar",
    },
    userText: {
      type: String,
      required: false,
      default: "Usuario",
    },
    desdeText: {
      type: String,
      required: false,
      default: "Desde",
    },
    hastaText: {
      type: String,
      required: false,
      default: "Hasta",
    },
    imprimirEirMaquinaText: {
      type: String,
      required: false,
      default: "Imprimir EIR Máquina",
    },
    codigoCliente: {
      type: String,
      required: false,
      default: "",
    },
    codigoPatio: {
      type: String,
      required: false,
      default: "",
    },
    contenedor: {
      type: String,
      required: false,
      default: "",
    },
    secuencia: {
      required: false,
      default: undefined,
    },
    patios: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    puedeEditar: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_status: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_eliminar: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_gate_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_out: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_caja: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_editar_maquina: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_in: {
      type: Boolean,
      required: false,
      default: false
    },
    puede_enviar_edi_out: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      patioDefault: patioDefault,
      moneyFormat: moneyFormat,
      pathSinImagen: url + "/images/sin-imagen.jpg",
      form: {
        selectedContenedor: null,
        modulo: "EST",
        codigo_cliente: this.codigoCliente,
        secuencia: this.secuencia,
      },
      procesosConsultados: [],
      errores: {
        selectedContenedor: undefined,
        modulo: undefined,
      },
      url: url,
      srcImagen: "",
      propiedadConsultada: null,
      codCliente: this.codigoCliente,
      codPatio: this.codigoPatio,
      primeraVez: true,
      imagenTitle: "",
      selectedPatio: null,
      currentUnidad: null,
    };
  },
  mounted: function () {
    if (this.contenedor !== "") {
      this.form.selectedContenedor = {
        number: this.contenedor,
      };
      this.consultar();
    }
    else {
      if (this.patioDefault != null && this.patioDefault != '') {
        for (let i = 0; i < this.patios.length; i++) {
          if (this.patios[i].code == this.patioDefault) {
            this.selectedPatio = this.patios[i];
            break;
          }
        }
      }
      
    }
  },
  computed: {
    contenedoresFiltrados: function () {
      if (this.patios.length > 0) {
        let contenedores = [];
        if (this.selectedPatio !== null) {
          for (let i = 0; i < this.contenedores.length; i++)
            if (this.contenedores[i].yard_code == this.selectedPatio.code)
              contenedores.push(this.contenedores[i]);
        }
        return contenedores;
      } else return this.contenedores;
    },
  },
  methods: {
    inputPatio: function () {
      this.form.selectedContenedor = null;
    },
    verLogs: function (tipo) {
      window.open(
        this.url +
        "/reparacion?container=" +
        this.propiedadConsultada.number +
        "&tipo=" +
        tipo,
        "_blank"
      );
    },
    tabChanged: function (selectedTab) {
      this.form.modulo = selectedTab.tab.id;
      if (!this.primeraVez) this.consultar();
      else this.primeraVez = false;
    },
    imprimirEirMaquina: function () {
      let secuencia = "";
      if (this.form.secuencia !== undefined)
        secuencia = "&secuencia=" + this.form.secuencia;
      window.open(
        this.url +
        "/eir?eir=" +
        this.propiedadConsultada.eir_maquina_in +
        "&tipo=in&tipo_eir=M" +
        secuencia,
        "_blank"
      );
    },
    eirEnviado: function () {
      this.$modal.hide("enviarEir");
    },
    cancelarCorreo: function () {
      this.$modal.hide("enviarEir");
    },
    enviarCorreos: function () {
      this.$modal.show("enviarEir");
    },
    imprimirEir: function () {
      let secuencia = "";
      if (this.form.secuencia !== undefined)
        secuencia = "&secuencia=" + this.form.secuencia;
      window.open(
        this.url +
        "/eir?eir=" +
        this.propiedadConsultada.eir_in +
        "&tipo=in&tipo_eir=C" +
        secuencia,
        "_blank"
      );
    },
    imprimirEirOut: function () {
      let secuencia = "";
      if (this.form.secuencia !== undefined)
        secuencia = "&secuencia=" + this.form.secuencia;
      window.open(
        this.url +
        "/eir?eir=" +
        this.propiedadConsultada.eir_out +
        "&tipo=out" +
        secuencia,
        "_blank"
      );
    },
    cerrarVisor: function () {
      this.$modal.hide("visor");
    },
    verImagen: function (imagen, title = undefined) {
      if (title !== undefined) this.imagenTitle = title;
      else this.imagenTitle = imagen.url;
      this.srcImagen = imagen.url;
      this.$modal.show("visor");
    },
    copiarLinks: function () {
      let urls = "";
      for (let i = 0; i < this.procesosConsultados.length; i++)
        for (let j = 0; j < this.procesosConsultados[i].imagenes.length; j++)
          urls +=
            (i === 0 ? "" : ",") + this.procesosConsultados[i].imagenes[j].url;
      this.copiarLink(urls);
    },
    copiarLink: function (url) {
      let temp = document.createElement("input");
      document.body.appendChild(temp);
      temp.value = url;
      temp.select();
      document.execCommand("copy");
      temp.remove();
    },
    descargarTodos: function () {
      let imagenes = [];
      let that = this;
      for (let i = 0; i < this.procesosConsultados.length; i++)
        for (let j = 0; j < this.procesosConsultados[i].imagenes.length; j++)
          imagenes.push(this.procesosConsultados[i].imagenes[j].path);
      axios
        .post(this.url + "/contenedores/descargar", {
          imagenes: imagenes,
        })
        .then(function (response) {
          location.href = response.data;
        })
        .catch(function (error) {
          swal(that.$t("message.errorText"), that.$t("message.error"), "error");
        });
    },
    changeFecha: function () {
      this.form.desde = "";
      this.form.hasta = "";
      this.consultar();
    },
    changePersonalizada: function () {
      let weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      let date = new Date();
      this.form.desde = moment(weekAgo).format("YYYY-MM-DD");
      this.form.hasta = moment(date).format("YYYY-MM-DD");
      this.consultar();
    },
    consultar: function () {
      let that = this;
      that.errores = {};
      if (that.propiedadConsultada !== null) {
        that.propiedadConsultada.firma_supervisor_sal = null;
      }
      axios
        .post(url + "/contenedores", that.form)
        .then(function (response) {
          that.procesosConsultados = response.data.imagenes;
          that.propiedadConsultada = response.data.propiedad;
        })
        .catch(function (error) {
          if (error !== null && error !== undefined) {
            let response = error.response;
            if (response !== undefined && response !== null) {
              let status = response.status;
              if (status === 422) that.errores = response.data.errors;
              else
                swal(
                  that.$t("message.errorText"),
                  that.$t("message.error"),
                  "warning"
                );
            }
          }
        });
    },
    editarPropiedades: function () {
      this.$modal.show("editarPropiedades");
    },
    eliminarUnidad: function () {
      if (location.pathname === '/contenedores') {
        location.replace(this.url + '/contenedores');
        return;
      }
    },
    cerrarUnidad: function () {
      this.quitarShorcutUnidad();
      this.$modal.hide('editarPropiedades');
    },
    quitarShorcutUnidad: function () {
      document.removeEventListener("keydown", this.$refs.editarUnidad.pressed);
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/clientes/ConsultaContenedores.vue